import React from 'react';
import classes from './classes.module.scss';
import withPGTranslation from '../../../config/withPGTranslation';

function CallAnimation({
  pictureSrc, borderColor
}) {
  return (
    <div className= { classes.frameOut }>
      <div className={ classes.frameMid }>
        <div className={ classes.frameIn }>
          <img
            className={ classes.profilePicture }
            style={ { '--color': borderColor } }
            src={ pictureSrc }
            alt="Profile"
          />
        </div>
      </div>
    </div>
  );
}
export default withPGTranslation(CallAnimation);
